/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { Component } from "react";
import { connect } from "react-redux";
// import { Accordion, Card } from "react-bootstrap";
// import _ from "lodash";
import Pagination from "react-js-pagination";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import { getMyTeam, getMyTeamExport } from "actions";
// import "components/invoices/invoice.css";
import MembersTable from "components/myteam/MembersTable";
import { Trans } from "react-i18next";
import i18n from "i18next";

class MyTeam extends Component {
  state = {
    teamFetched: false,
    filteredTeamData: [],
    filterTerm: "",
    error: null,
    activePage: 1,
  };

  settings = {
    itemsPerPage: 10,
  };

  componentDidMount() {
    this.fetchMyTeam();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredTeamData: this.props.myTeam.items.filter((member) => {
          return member.fullname
            .toLowerCase()
            .includes(this.state.filterTerm.toLowerCase());
        }),
      });
    }
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onSuccess = (res) => {
    this.props.onProcessEnd();

    this.setState({
      teamFetched: true,
      filteredTeamData: this.props.myTeam.items,
    });
  };

  fetchMyTeam = () => {
    this.props.getMyTeam(this.onBegin, this.onSuccess, this.onError);
  };

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFetch = () => {
    this.setState({ teamFetched: false });
    this.fetchMyTeam();
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value });
  };

  handleExport = () => {
    this.props.getMyTeamExport(
      this.onBegin,
      this.onExportSuccess,
      this.onError
    );
  };

  onExportSuccess = (res, fname) => {
    this.props.onProcessEnd();
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fname);
    document.body.appendChild(link);
    link.click();
  };

  renderTableToolbar = () => {
    return (
      <div className="row align-items-center py-3 eduTitleArea">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 tableSearchArea">
              <div className="inner-addon right-addon">
                <span className="iconmford fo-icon-search"></span>
                <input
                  type="text"
                  name="tableSearch"
                  id="tableSearch"
                  className="form-control"
                  placeholder={i18n.t("10053")}
                  onChange={(e) => this.handleFilter(e)}
                  value={this.state.filterTerm}
                />
              </div>
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <button className="export-button" onClick={this.handleExport}>
                  <Trans desc="Dışa Aktar">10113</Trans>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderPager = () => {
    return (
      <div
        style={{
          display: "grid",
          justifyContent: "right",
          marginRight: "20px",
        }}
      >
        <Pagination
          hideFirstLastPages={true}
          prevPageText="Önceki"
          nextPageText="Sonraki"
          hideDisabled={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={this.state.filteredTeamData.length}
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  render() {
    if (!this.state.teamFetched) {
      return this.props.spinner;
    }

    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;

    return (
      <section className="sssArea my-3">
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>

                </li>
                <li>
                  <a href="#" style={{ verticalAlign: "middle" }}>
                    <Trans desc="Şirket Bilgileri">10024</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Ekibim">10028</Trans>
                </li>
              </ul>
            </div>
          </div>
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <div className="profilBaslik">
                <Trans desc="Ekibim">10028</Trans>
              </div>
            </div>
          </div>

          {this.renderTableToolbar()}

          <div className="row py-4 bottomRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <MembersTable
                data={this.state.filteredTeamData.slice(start, end)}
              />
            </div>
          </div>
          <div className="row py-4 bottomRow">
            <div className="col-xs-0 col-sm-0 col-md-9 col-lg-9"></div>
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
              {this.renderPager()}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = ({ myTeam, application }) => {
  return {
    myTeam: myTeam.data,
    application,
  };
};

export default connect(mapStateToProps, { getMyTeam, getMyTeamExport })(
  containsLongRunningProcess(requireAuth(MyTeam))
);
